import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedMensajeConfirmacion, sharedNextPage } from "../../../utils/shared-functions";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
// import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { COLOR_VERDE_MAIN } from "../../../utils/const/colors-const";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { deshabilitarSolicitudProducto, habilitarSolicitudProducto, obtenerListaSolicitudProducto } from "../../../api/api-solicitud-producto";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import { obtenerListaKanban } from "../../../api/api-kanban";
import ProgramacionSolicitudProductoCard from "../../../components/programacion-solicitud-producto-card";
import ProgramacionViajeCardComponent from "../../../components/programacion-viaje-card-component";
import ModalConfigAccionesProgramacionKanban from "../../../components/modal-config-acciones-programacion-kanban";
import {
  actualizarWorkflowProgramacionSolicitudProducto,
  crearConfigProgramacionKanbanDefault,
  crearWorkflowProgramacionSolicitudProducto,
  normalizarConfigProgramacionKanban,
  obtenerListaWorkflowProgramacionSolicitudProducto,
} from "../../../api/api-workflow-programacion-solicitud-producto";
import {
  actualizarStatusKanban,
  guardarStatusKanban,
  obtenerStatusKanban,
} from "../../../api/api-status-kanban";
import { obtenerListaProgramacionCamionesAprobados } from "../../../api/api-programacion-camiones";
import { obtenerListaPersona } from "../../../api/api-persona";
import { Save, Settings } from "lucide-react";

let $ = window.$;

const parseProgramacionCamionesItem = (row) => {
  let respuestasParsed = [];
  try {
    if (typeof row?.respuestas === "string" && row.respuestas.trim().length > 0) {
      respuestasParsed = JSON.parse(row.respuestas);
    } else if (Array.isArray(row?.respuestas)) {
      respuestasParsed = row.respuestas;
    }
  } catch (err) {
    console.log("parseProgramacionCamionesItem err");
    console.log(err);
  }
  return {
    ...row,
    respuestasParsed,
  };
};

const buildAccionesConfigByColumn = (kanbanLista, configLista) => {
  const nextConfig = {};
  const configsByKanban = {};

  (Array.isArray(configLista) ? configLista : []).forEach((config) => {
    if (!config?.idKanban) return;
    // Ignore old composite keys like columnId__accionId
    if (String(config.idKanban).includes("__")) return;
    configsByKanban[config.idKanban] = config;
  });

  (Array.isArray(kanbanLista) ? kanbanLista : []).forEach((column) => {
    const saved = configsByKanban[column.id];
    nextConfig[column.id] = normalizarConfigProgramacionKanban(
      saved ??
      crearConfigProgramacionKanbanDefault({
        idKanban: column.id,
        acciones: column.acciones,
      }),
      column.acciones
    );
  });

  return nextConfig;
};

const getAccionConfigFromColumn = (columnConfig, idAccion) => {
  const acciones = Array.isArray(columnConfig?.acciones) ? columnConfig.acciones : [];
  return acciones.find((accion) => String(accion.idAccion) === String(idAccion)) ?? null;
};

const parseStatusChildren = (children) => {
  if (Array.isArray(children)) return children;
  if (typeof children === "string" && children.trim()) {
    try {
      const parsed = JSON.parse(children);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }
  return [];
};

const buildKanbanItemsFromStatus = (
  kanbanLista,
  programacionLista,
  statusLista
) => {
  const itemsByColumn = (Array.isArray(kanbanLista) ? kanbanLista : []).reduce(
    (acc, column) => {
      acc[column.id] = [];
      return acc;
    },
    {}
  );
  const status = Array.isArray(statusLista) ? statusLista : [];
  const firstColumn = [...(Array.isArray(kanbanLista) ? kanbanLista : [])].sort(
    (a, b) => (a.orden ?? 0) - (b.orden ?? 0)
  )[0];

  if (status.length > 0) {
    const savedCardIds = new Set();

    status.forEach((columnStatus) => {
      if (!Object.prototype.hasOwnProperty.call(itemsByColumn, columnStatus?.idKanban)) {
        return;
      }
      const savedChildren = parseStatusChildren(columnStatus.children).map(
        parseProgramacionCamionesItem
      );
      savedChildren.forEach((item) => {
        if (item?.id != null) savedCardIds.add(String(item.id));
      });
      itemsByColumn[columnStatus.idKanban] = savedChildren;
    });

    // Only the first column receives records that are new and not present
    // in any column from the last saved board status.
    if (firstColumn) {
      const newItems = programacionLista.filter(
        (item) => item?.id != null && !savedCardIds.has(String(item.id))
      );
      itemsByColumn[firstColumn.id] = [
        ...(itemsByColumn[firstColumn.id] ?? []),
        ...newItems,
      ];
    }

    return itemsByColumn;
  }

  if (firstColumn) {
    itemsByColumn[firstColumn.id] = programacionLista;
  }
  return itemsByColumn;
};

export default function ListarProgramacionSolicitudProductoPage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  // const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  // const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  // const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  // const [rowsData, setRowsData] = useState([]);
  const [btnBuscar, setBtnBuscar] = useState(false);
  const [btnNuevo, setBtnNuevo] = useState(false);
  // const [btnModificar, setBtnModificar] = useState(false);
  // const [btnDeshabilitar, setBtnDeshabilitar] = useState(false);
  // const [btnHabilitar, setBtnHabilitar] = useState(false);

  // const [btnConfigurar, setBtnConfigurar] = useState(false);
  const [btnGuardar, setBtnGuardar] = useState(false);
  // Toast only (success / error messages)
  const { showToast } = useToast();
  // Processing overlay only (loading while API runs)
  const { showProcessing, hideProcessing } = useProcessing();

  const [productosRequerimiento, setProductosRequerimiento] = useState([]);
  const [listaKanban, setListaKanban] = useState([]);
  const [listaProgramacionCamiones, setListaProgramacionCamiones] = useState([]);
  const [kanbanItemsByColumn, setKanbanItemsByColumn] = useState({});
  const [statusKanbanId, setStatusKanbanId] = useState(null);
  const [accionesConfigByColumn, setAccionesConfigByColumn] = useState({});
  const [modalConfigVisible, setModalConfigVisible] = useState(false);
  const [columnConfigSelected, setColumnConfigSelected] = useState(null);

  const [listaPersonas, setListaPersonas] = useState([]);
  const [personasSelected, setPersonasSelected] = useState(null);


  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      objEnviar.idTablero = null;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        // setBtnNuevo(true);
        // setBtnModificar(true);
        // setBtnDeshabilitar(true);
        // setBtnHabilitar(true);
        setBtnGuardar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 8);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.GESTIONAR_PROGRAMACION_SOLICITUD_PRODUCTO);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              // const permisoBtnNuevo = permisosPage.acciones.find(a => a.value === 'btn_nuevo');
              // const permisoBtnModificar = permisosPage.acciones.find(a => a.value === 'btn_modificar');
              // const permisoBtnDeshabilitar = permisosPage.acciones.find(a => a.value === 'btn_deshabilitar');
              // const permisoBtnHabilitar = permisosPage.acciones.find(a => a.value === 'btn_habilitar');
              const permisoBtnGuardar = permisosPage.acciones.find(a => a.value === 'btn_guardar');
              setBtnBuscar(permisoBtnBuscar?.checked);
              // setBtnNuevo(permisoBtnNuevo?.checked);
              // setBtnModificar(permisoBtnModificar?.checked);
              // setBtnDeshabilitar(permisoBtnDeshabilitar?.checked);
              // setBtnHabilitar(permisoBtnHabilitar?.checked);
              setBtnGuardar(permisoBtnGuardar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        const [productos, kanban, programacionCamiones, personas, responseConfig] =
          await Promise.all([
            obtenerListaSolicitudProducto(objEnviar, false, t),
            obtenerListaKanban(objEnviar, false, t),
            obtenerListaProgramacionCamionesAprobados(objEnviar, false, t),
            obtenerListaPersona({ habilitado: 1 }, true),
            obtenerListaWorkflowProgramacionSolicitudProducto(),
          ]);
        // Load the last saved board status after all other page data is ready.
        const responseStatus = await obtenerStatusKanban({ idTablero: null });
        console.log('responseStatus');
        console.log(responseStatus);
        // let lista = [];
        // console.log('productos');
        // console.log(productos);
        // productos = await obtenerListaSolicitudProducto(objEnviar, false, t);
        // setRowsData(lista);
        const productosLista = Array.isArray(productos) ? productos : [];
        const kanbanLista = Array.isArray(kanban) ? kanban : [];
        const programacionLista = (Array.isArray(programacionCamiones) ? programacionCamiones : []).map(
          parseProgramacionCamionesItem
        );
        setProductosRequerimiento(productosLista);
        console.log('kanban');
        console.log(kanban);
        setListaKanban(kanbanLista);
        setListaProgramacionCamiones(programacionLista);
        setStatusKanbanId(responseStatus?.id ?? null);
        setKanbanItemsByColumn(
          buildKanbanItemsFromStatus(
            kanbanLista,
            programacionLista,
            responseStatus?.error === false ? responseStatus.data : []
          )
        );

        setAccionesConfigByColumn(
          buildAccionesConfigByColumn(kanbanLista, responseConfig?.data ?? [])
        );

        // console.log('programacionCamiones');
        // console.log(programacionCamiones);
        // console.log('personas');
        // console.log(personas);
        setListaPersonas(Array.isArray(personas) ? personas : []);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleAccionKanban = (accion, item, column) => {
    console.log("accion kanban", { accion, item, column });

    const columnConfig = accionesConfigByColumn[column.id] ?? null;
    const accionConfig = getAccionConfigFromColumn(columnConfig, accion.id);
    const targetColumnId = accionConfig?.moverAKanban?.value ?? null;

    if (!targetColumnId) {
      showToast(t("alert_configure_acciones_programacion_kanban"), "warning", 3500);
      setColumnConfigSelected(column);
      setModalConfigVisible(true);
      return;
    }

    setKanbanItemsByColumn((prev) => {
      const sourceItems = prev[column.id] ?? [];
      const movingItem = sourceItems.find((card) => String(card.id) === String(item.id));
      if (!movingItem) return prev;

      const next = { ...prev };
      next[column.id] = sourceItems.filter((card) => String(card.id) !== String(item.id));
      const targetItems = next[targetColumnId] ?? [];
      if (!targetItems.some((card) => String(card.id) === String(item.id))) {
        next[targetColumnId] = [...targetItems, movingItem];
      }
      return next;
    });

    // console.log("notificar accion kanban", {
    //   mensaje: accionConfig?.mensaje,
    //   notificarA: accionConfig?.notificarA,
    //   moverAKanban: accionConfig?.moverAKanban,
    // });

    showToast(
      accionConfig?.mensaje || t("alert_card_movida_kanban"),
      "success",
      3000
    );
  };

  const handleOpenConfigColumn = (column) => {
    setColumnConfigSelected(column);
    setModalConfigVisible(true);
  };

  const handleSaveConfigColumn = async (config) => {
    if (!columnConfigSelected?.id) return;

    const payload = {
      ...config,
      idKanban: columnConfigSelected.id,
      id: accionesConfigByColumn[columnConfigSelected.id]?.id ?? config.id ?? null,
    };
    const accionesMeta = columnConfigSelected.acciones ?? [];

    showProcessing();
    const response = payload.id
      ? await actualizarWorkflowProgramacionSolicitudProducto(payload, accionesMeta)
      : await crearWorkflowProgramacionSolicitudProducto(payload, accionesMeta);
    hideProcessing();

    if (response.error === true) {
      showToast(response.message || t("alert_no_se_pudo_crear"), "error", 3000);
      return;
    }

    setAccionesConfigByColumn((prev) => ({
      ...prev,
      [columnConfigSelected.id]: response.data,
    }));

    setModalConfigVisible(false);
    setColumnConfigSelected(null);
    showToast(t("label_guardar"), "success", 2000);
  };

  const listaKanbanOrdenada = [...(Array.isArray(listaKanban) ? listaKanban : [])].sort(
    (a, b) => (a.orden ?? 0) - (b.orden ?? 0)
  );

  const handleGuardarEstado = async () => {
    const estadoKanban = listaKanbanOrdenada.map((kanban) => ({
      idKanban: kanban.id,
      descripcion: kanban.descripcion,
      orden: kanban.orden,
      children: [...(kanbanItemsByColumn[kanban.id] ?? [])],
    }));

    console.log('estadoKanban', estadoKanban);

    showProcessing();
    const response = statusKanbanId
      ? await actualizarStatusKanban(statusKanbanId, estadoKanban, null)
      : await guardarStatusKanban(estadoKanban, null);
    hideProcessing();

    if (response.error === true) {
      showToast(response.message || t("alert_no_se_pudo_crear"), "error", 3000);
      return;
    }

    if (!statusKanbanId && response.id) {
      setStatusKanbanId(response.id);
    }

    showToast(
      response.message || t("label_guardar_estado"),
      "success",
      2000
    );
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_programacion_solicitud_producto")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_programacion_solicitud_producto")}</p>
            </div>
            {btnBuscar && (
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={() => {
                    reset();
                  }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            )}
          </div>
          {btnGuardar && (
            <div className="flex items-center gap-2">
              <button
                type="button"
                className={`${ESTILO_BOTON_LISTAR_NUEVO} group transition-all duration-200 ease-out hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 active:scale-95`}
                onClick={() => {
                  handleGuardarEstado();
                }}
              >
                <Save className="h-4 w-4 mr-2 inline-block transition-transform duration-200 group-hover:scale-110 group-hover:-rotate-6" />
                {t("label_guardar_estado")}
              </button>
            </div>
          )}
          <hr />

          <div className="flex gap-4 overflow-x-auto items-start py-4 pb-6">
            <div className="flex flex-col w-80 shrink-0 bg-gray-50 border border-gray-200 rounded-lg overflow-hidden">
              <div className="px-3 py-2.5 border-b border-gray-200 bg-white">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-sm font-semibold text-gray-900 truncate">
                    {t("label_productos")}
                  </h3>
                  <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full shrink-0">
                    {productosRequerimiento.length}
                  </span>
                </div>
              </div>
              <div className="flex-1 min-h-[280px] max-h-[calc(100vh-280px)] overflow-y-auto p-2 space-y-2">
                {productosRequerimiento.length === 0 ? (
                  <div className="flex items-center justify-center h-24 text-xs text-gray-400 border border-dashed border-gray-200 rounded-lg">
                    {t("label_sin_datos")}
                  </div>
                ) : (
                  productosRequerimiento.map((item) => (
                    <ProgramacionSolicitudProductoCard key={item.id} item={item} />
                  ))
                )}
              </div>
            </div>

            {listaKanbanOrdenada.map((column) => {
              const columnItems = kanbanItemsByColumn[column.id] ?? [];
              return (
                <div
                  key={column.id}
                  className="flex flex-col w-80 shrink-0 bg-gray-50 border border-gray-200 rounded-lg overflow-hidden"
                >
                  <div className="px-3 py-2.5 border-b border-gray-200 bg-white">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="text-sm font-semibold text-gray-900 truncate">
                        {column.descripcion ?? "—"}
                      </h3>
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={() => handleOpenConfigColumn(column)}
                          className="p-1 rounded text-gray-400 hover:text-gray-700 hover:bg-gray-100"
                          title={t("label_configurar_acciones_programacion_kanban")}
                        >
                          <Settings className="h-4 w-4" />
                        </button>
                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full shrink-0">
                          {columnItems.length}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex-1 min-h-[280px] max-h-[calc(100vh-280px)] overflow-y-auto p-2 space-y-2">
                    {columnItems.length === 0 ? (
                      <div className="flex items-center justify-center h-24 text-xs text-gray-400 border border-dashed border-gray-200 rounded-lg">
                        {t("label_sin_datos")}
                      </div>
                    ) : (
                      columnItems.map((item) => (
                        <ProgramacionViajeCardComponent
                          key={item.id}
                          item={item}
                          acciones={column.acciones}
                          onAccionClick={(accion, cardItem) =>
                            handleAccionKanban(accion, cardItem, column)
                          }
                        />
                      ))
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <ModalConfigAccionesProgramacionKanban
            isOpen={modalConfigVisible}
            column={columnConfigSelected}
            listaKanban={listaKanbanOrdenada}
            listaPersonas={listaPersonas}
            initialConfig={
              columnConfigSelected
                ? accionesConfigByColumn[columnConfigSelected.id] ?? null
                : null
            }
            onCancel={() => {
              setModalConfigVisible(false);
              setColumnConfigSelected(null);
            }}
            onSave={handleSaveConfigColumn}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarTipoCarguio render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
